module.exports = __webpack_public_path__ + "assets/img/guide.3c91bd58.svg";